module.exports = __webpack_public_path__ + "img/logo2.8d680519.png";